import { axiosRequestRisks } from '../../../api/utils';

/**
 * Fetch-compatible wrapper over axiosRequestRisks (B2B Bearer via _auth).
 * Paths are relative to REACT_APP_BASE_URL_RISKS, e.g. /api/organizations.
 */
export async function apiFetch(path, options = {}) {
  const method = (options.method || 'GET').toLowerCase();
  const config = {
    url: path,
    method,
    _auth: true,
  };

  if (options.signal) {
    config.signal = options.signal;
  }

  if (options.body != null) {
    config.data =
      typeof options.body === 'string' ? JSON.parse(options.body) : options.body;
  }

  try {
    const res = await axiosRequestRisks.request(config);
    return makeResponse(res.status, res.data, res.headers);
  } catch (error) {
    const status = error.response?.status || 0;
    if (status === 401) {
      const hasToken = Boolean(localStorage.getItem('meridian_b2b_access_token'));
      throw new Error(
        hasToken
          ? 'Нет доступа к risk.mira.cloud (токен отклонён). Войдите заново в B2B.'
          : 'Нужна авторизация B2B — войдите в систему, затем откройте Риски.',
      );
    }
    if (!error.response) {
      throw error;
    }
    return makeResponse(status, error.response.data, error.response.headers);
  }
}

function makeResponse(status, data, headers = {}) {
  const headerMap = {};
  Object.entries(headers || {}).forEach(([k, v]) => {
    headerMap[String(k).toLowerCase()] = v;
  });
  if (!headerMap['content-type']) {
    headerMap['content-type'] = 'application/json';
  }

  return {
    ok: status >= 200 && status < 300,
    status,
    headers: {
      get(name) {
        return headerMap[String(name).toLowerCase()] || null;
      },
    },
    async json() {
      return data;
    },
    async text() {
      return typeof data === 'string' ? data : JSON.stringify(data ?? '');
    },
  };
}

export async function readJsonResponse(response, label) {
  const contentType = response.headers.get('content-type') || '';

  if (!contentType.includes('application/json')) {
    const preview = (await response.text()).slice(0, 120);
    throw new Error(
      `${label}: ожидался JSON, получен ${contentType || 'неизвестный тип'} (${preview})`
    );
  }

  return response.json();
}
